const accessToken = `pk.eyJ1IjoiYWxwYWNhdHJhdmVsIiwiYSI6ImNsc21uYTc1azBiZjMyaW1teGR2cno1OGUifQ.q5LVedwatVzA2I3ZlIyczA`;

const useMapboxAccessToken = () => {
  return { accessToken };
};

export default useMapboxAccessToken;
